import { ParameterType } from '@/study-search/enums';

import { DegreeTypeFilterOptionValue } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';

class ShortCoursesDegreeTypeFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DEGREE_TYPE,
			[
				new FilterOptionInformation(
					'Certificate',
					DegreeTypeFilterOptionValue.CERTIFICATE,
					'certificate',
					'Certificate'
				),
				new FilterOptionInformation('Advanced Diploma', DegreeTypeFilterOptionValue.ADVANCED_DIPLOMA, '', '')
			],
			[DegreeTypeFilterOptionValue.CERTIFICATE]
		);
	}
}

export default new ShortCoursesDegreeTypeFilterDefinition();
